import { useStaticQuery, graphql } from 'gatsby';

interface AffiliateDetails {
  affiliateType: 'rehoming' | 'vet' | 'breeder';
  affiliateTypeMappingId: 1 | 2 | 3 | undefined;
  isOwnerActivated: boolean;
}

export const useAffiliateDetails = (): AffiliateDetails => {
  const { site } = useStaticQuery(graphql`
    query GetAffiliateIdQab {
      site {
        siteMetadata {
          affiliateType
          isOwnerActivated
        }
      }
    }
  `);

  let affiliateTypeMappingId;
  switch (site.siteMetadata?.affiliateType) {
    case 'rehoming':
      affiliateTypeMappingId = 1;
      break;
    case 'vet':
      affiliateTypeMappingId = 2;
      break;
    case 'breeder':
      affiliateTypeMappingId = 3;
      break;
    default:
      affiliateTypeMappingId = undefined;
  }
  return { ...site.siteMetadata, affiliateTypeMappingId };
};
